var React = require('react');

function Tick (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.546 8.71a1.004 1.004 0 0 0-1.423.003l-5.506 5.505-2.026-2.026a1.003 1.003 0 0 0-1.413.008l.032-.033a1.006 1.006 0 0 0-.005 1.415l2.691 2.692a1 1 0 0 0 1.409.004l6.214-6.19a1 1 0 0 0-.006-1.41l.033.032z","fill":"currentColor"}));
}

Tick.defaultProps = {"width":"25","height":"25","viewbox":"0 0 25 25"};

module.exports = Tick;

Tick.default = Tick;
